import qs from "query-string";

const API_ROUTE_PREFIX = "/api";
const DEFAULT_API_VERSION = 1;

export function getApiUrl(version) {
    return `${API_ROUTE_PREFIX}/v${version || DEFAULT_API_VERSION}`;
}

export const wevosUrl = (teamId, params) =>
    `${getApiUrl()}/teams/${teamId}/wevos${
        !params ? "" : `?${qs.stringify(params)}`
    }`;



// WEBPACK FOOTER //
// ./src/helpers/api.js